import rest from "../script/rest";

class AntennaRest {

    async getManufacturers() {
        const url = "/rest/antenna/getManufacturers";
        const response = await rest.get(url);
        return response.json();
    }

    async getAntennasByManufacturer(antennaManufacturer) {
        let url = "/rest/antenna/getAntennas";
        if (antennaManufacturer) {
            url += "?antennaManufacturer=" + encodeURIComponent(antennaManufacturer);
        }
        const response = await rest.get(url);
        return response.json();
    }

    async getAntennasByNames(names) {
        let url = "/rest/antenna/getAntennas";
        if (names) {
            url += "?";
            url += names.map(name => `antennaName=${name}`).join("&");
        }
        const response = await rest.get(url);
        return response.json();
    }

    async getLazy(from, pageSize, searchStr) {
        const url = "/rest/antenna/getLazy"
            + "?from=" + from
            + "&pageSize=" + pageSize
            + "&searchStr=" + encodeURIComponent(searchStr ?? "");
        const response = await rest.get(url);
        return response.json();
    }

    async getFrequencies(antennaName) {
        if (!antennaName) {
            return [];
        }
        const url = "/rest/antenna/getFrequencies"
            + "?antennaName=" + encodeURIComponent(antennaName);
        const response = await rest.get(url);
        return response.json();
    }

    async getAntennaSystems(antennaName) {
        if (!antennaName) {
            return [];
        }
        const url = "/rest/antenna/getAntennaSystems"
            + "?antennaName=" + encodeURIComponent(antennaName);
        const response = await rest.get(url);
        return response.json();
    }

    async getPorts(antennaName, antennaFrequency) {
        if (!antennaName || !antennaFrequency) {
            return [];
        }
        const url = "/rest/antenna/getPorts"
            + "?antennaName=" + encodeURIComponent(antennaName)
            + "&antennaFrequency=" + antennaFrequency;
        const response = await rest.get(url);
        return response.json();
    }

    async getElecDowntilts(antennaName, antennaFrequency, antennaPort) {
        if (!antennaName || !antennaFrequency || !antennaPort) {
            return [];
        }
        const url = "/rest/antenna/getElecDowntilts"
            + "?antennaName=" + encodeURIComponent(antennaName)
            + "&antennaFrequency=" + antennaFrequency
            + "&antennaPort=" + encodeURIComponent(antennaPort);
        const response = await rest.get(url);
        return response.json();
    }

    async getMinElecDowntilts(antennaPortRefs) {
        const url = "/rest/antenna/getMinElecDowntilts";
        const response = await rest.post(url, antennaPortRefs);
        return response.json();
    }

    async getMaxElecDowntilts(antennaPortRefs) {
        const url = "/rest/antenna/getMaxElecDowntilts";
        const response = await rest.post(url, antennaPortRefs);
        return response.json();
    }

    async getMaxElecDowntiltAntenna(antennaName, antennaFrequency) {
        if (!antennaName || !antennaFrequency) {
            return [];
        }
        const url = "/rest/antenna/getMaxElecDowntiltAntenna"
            + "?antennaName=" + encodeURIComponent(antennaName)
            + "&antennaFrequency=" + antennaFrequency;
        const response = await rest.get(url);
        return response.json();
    }

    async getAntennaSystemField(antennaName, antennaFrequency) {
        if (!antennaName || !antennaFrequency) {
            return [];
        }
        const url = "/rest/antenna/getAntennaSystemField"
            + "?antennaName=" + encodeURIComponent(antennaName)
            + "&antennaFrequency=" + antennaFrequency;
        const response = await rest.get(url);
        return response.json();
    }

    async getAntennaData(antennaName, antennaFrequency, opFrequency, antennaPort, antennaElecDowntilt) {
        const params = new URLSearchParams();
        if (antennaName) {
            params.append("antennaName", antennaName);
        }
        if (antennaFrequency) {
            params.append("antennaFrequency", antennaFrequency);
        }
        if (opFrequency) {
            params.append("opFrequency", opFrequency);
        }
        if (antennaPort) {
            params.append("antennaPort", antennaPort);
        }
        if (antennaElecDowntilt) {
            params.append("antennaElecDowntilt", antennaElecDowntilt);
        }
        const url = "/rest/antenna/getAntennaData?" + params.toString();
        const response = await rest.get(url);
        return response.json();
    }

    async getAntennaInfo(antennaInfoArray) {
        const url = "/rest/antenna/getAntennaInfo";
        const response = await rest.post(url, antennaInfoArray);
        return response.json();
    }

    async insert(antenna) {
        const url = "/rest/antenna/insert";
        const response = await rest.post(url, antenna);
        return response.json();
    }

    async update(antenna) {
        const url = "/rest/antenna/update";
        const response = await rest.post(url, antenna);
        return response.json();
    }

    async importAntennas(name, file) {
        const url = "/rest/antenna/import";
        const response = await rest.file(url, name, file);
        return response.text();
    }
}
const antennaRest = new AntennaRest();
window.antennaRest = antennaRest;
export default antennaRest;